<style>
    .ivu-vueCheckbox {
        width : 100%;
        height : 100%;
    }
    .ivu-vueCheckbox-div {
        /* -webkit-transform:scale(0.8); */
        width : 100%;
        height : 100%;
        position: absolute;
        padding : 0;
    }
</style>

<template>
    <div 
        class="ivu-vueCheckbox-div"
        v-if="isShow"
        :style="CheckboxStyle">
        <Checkbox v-model="checkedNames" @on-change="onChange" :style="fontStyleSet" :disabled="isAbled">{{name}}</Checkbox>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>

<script>
export default {
    name : "",
    props : ["primitives","fvSystemApi","parentObject"],
    created(){
         //窗口边框宽度。计算图元和组件位置时需要
        this.defaultTailoring = this.parentObject.defaultTailoring;
        //窗口大小
        this.windowSize = this.parentObject.windowSize;
        this.create();
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
    },
    data(){
        return {
            isShow : true,
            isEnable : false,
            checkedNames : false, //是否选中
            CheckboxStyle : "",
            fontStyleSet:"",
            name:"",
            isAbled:false,
        }
    },
    methods : {
        create() {
            this.mixin(this.primitives);
            this.windowsObject = this.$parent.$parent;
            this.workbench = this.windowsObject.workbench;
            //初始化位置
            this.CheckboxStyle = {
                left : 0 + "px",
                top : 0 + "px",
                width : 0 + "px",
                height : 0 + "px",
                overflow: "hidden"
            }
            this.enableStyle = {
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0px",
                backgroundColor: "#ccbfbf",
                opacity: "0.5"
            }
            var tempText = this.fvSystemApi.getResource(this.content);
            if(tempText){
                this.name = tempText;
            }else{
                this.name = this.content;
            }
            
            //设置样式
            this.fontStyleSet = {
                fontSize:this.fontSize + "px",
                fontFamily:this.fontFamily,
                margin:0
            }
            if(this.fontStyle){
                this.fontStyleSet.fontStyle = "oblique";
            }
            if(this.fontWeight){
                this.fontStyleSet.fontWeight = "bold";
            }
            var colors = FColorToRGB.getColors();
            //字体颜色
            var rgb = "RGB(" + colors[this.fontColor][0] + "," + colors[this.fontColor][1] + "," + colors[this.fontColor][2] +")";
            this.fontStyleSet.color = rgb;
            if(this.isSet==1){
                this.checkedNames = true;
            }else{
                this.checkedNames = false;
            }
            this.monitor();
            if(this.Change && this.Change != "%Change%"){
                this.Change = AsyncFunction("zIndex",this.Change);
            }
            if(this.Click && this.Click != "%Click%"){
                this.Click = AsyncFunction("zIndex",this.Click);
            }
        },
        //混入属性
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){},
        reDraw(scaleObj) {
            var tempText = this.fvSystemApi.getResource(this.content);
            if(tempText){
                this.name = tempText;
            }else{
                this.name = this.content;
            }
            this.CheckboxStyle.fontSize = (12 * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy + "px"; 
            this.CheckboxStyle.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.CheckboxStyle.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
            this.CheckboxStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.CheckboxStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            if(window.isApp() && scaleObj.isApp){
                this.CheckboxStyle.width = parseInt(this.width) + "px";
                this.CheckboxStyle.height = parseInt(this.height) + "px";
            }
        },
        onTimer(){
            if(this.isEnable) return;
            this.isAbled = false;
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true:false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
            this.isAbled = true;
        },
       /*
            参数：0：未选中，1：选中
            作用：设置选中状态
        */
        SetChecked(int){
            if(int > 0){
                this.checkedNames = true;
            }else{
                this.checkedNames = false;
            }
        },
       /*
            参数：
            作用：获取当前是否为选中状态，选中返回1，未选中返回0
        */
        GetChecked(){
            if(this.checkedNames){
                return 1;
            }else{
                return 0;
            }
        },
        /*
            参数：
            作用：返回选中文本
        */
        GetText(){
            return this.name;
        },
        /*
            参数：无
            作用：执行组件事件
        */
        onChange(){
            if(typeof this.Change == "function"){
               this.fvSystemApi.executionScript(this.Change,this.zIndex);
            }
            if(typeof this.Click == "function"){
                this.fvSystemApi.executionScript(this.Click,this.zIndex);
            }
        },

        monitor(){
            //监听选中状态
            Object.defineProperty(this,"State",{
                set(value){
                    this.checkedNames = value ? true : false;
                },
                get(){
                    return this.checkedNames ? 1 : 0;
                }
            })
            
            //监听属性显示的文字
            Object.defineProperty(this,"Title",{
                set(value){
                    this.name = value;
                },
                get(){
                    return this.name;
                }
            })

            //监听属性文本颜色
            Object.defineProperty(this,"Color",{
                set(value){
                    var defaultColor = FColorToRGB.getColors();
                    var colorTemp = defaultColor[value];
                    var color = "RGB(" + colorTemp[0] + "," + colorTemp[1] + "," + colorTemp[2] + ")";
                    this.$forceUpdate();
                    this.$set(this.fontStyleSet,'color',color);
                },
                get(){
                    return this.fontStyleSet.color;
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/fvCheckbox/fvCheckbox.vue